import React, { lazy } from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import AnalyticsLayout from 'app/modules/analytics/components/AnalyticsLayout';

const OverviewRoute = lazy(
  () => import('app/modules/analytics/modules/overview'),
);
const PerformanceRoute = lazy(
  () => import('app/modules/analytics/modules/performance'),
);
const ContentRoute = lazy(
  () => import('app/modules/analytics/modules/content'),
);
const CompetitionAnalysisRoute = lazy(
  () => import('app/modules/analytics/modules/competitionAnalysis'),
);
const ReportsListPage = lazy(
  () => import('app/modules/analytics/modules/reports/ReportsListPage'),
);
const CreateCustomReportPage = lazy(
  () => import('app/modules/analytics/modules/reports/modules/createReport'),
);
const EditReportPage = lazy(
  () =>
    import(
      'app/modules/analytics/modules/reports/modules/createReport/EditReportPage'
    ),
);

export const analyticsRouter: RouteObject = {
  path: routeConfig.analytics.path,
  element: <AnalyticsLayout />,
  children: [
    {
      index: true,
      element: (
        <Navigate to={routeConfig.analytics.routes.overview.path} replace />
      ),
    },
    {
      path: routeConfig.analytics.routes.overview.path,
      element: <OverviewRoute />,
    },
    {
      path: routeConfig.analytics.routes.performance.path,
      element: <PerformanceRoute />,
    },
    {
      path: routeConfig.analytics.routes.content.path,
      element: <ContentRoute />,
    },
    {
      path: routeConfig.analytics.routes.competitionAnalysis.path,
      element: <CompetitionAnalysisRoute />,
    },
    {
      path: routeConfig.analytics.routes.reports.path,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: <ReportsListPage />,
        },
        {
          path: routeConfig.analytics.routes.reports.routes.create.path,
          element: <CreateCustomReportPage />,
        },
        {
          path: routeConfig.analytics.routes.reports.routes.edit.path,
          element: <EditReportPage />,
        },
      ],
    },
  ],
};
